<template>
    <div class="layer_wrap">
        <div class="content" ref="content" :style="{height: height > 300 ? 300 + 'px' : 'auto'}">
            <scrollbar occupy>
                {{ content }}
            </scrollbar>
        </div>
        <div class="button_wrap">
            <BaseButton 
                v-for="(item,index) in buttons" 
                :key="item.key"
                class="button" 
                :call="obj  => buttonClick(item.key,obj)" 
                :style="{
                    marginRight: (index + 1) != buttons.length ? '20px' : 0
                }"
            >
                {{ item.label }}
            </BaseButton>
        </div>
    </div>
    
</template>

<script>
import BaseButton from '../components/BaseButton'
export default { 
    name: "MessageBox",
    components: {
        BaseButton
    },
    props: {
        content: {
            default: '',
            type: [String,Number]
        },
        buttons: Array
    },
    data: _=>({
        height: 0
    }),
    mounted() {
        let $content = this.$refs.content;
        this.height = $content.offsetHeight
    },
    methods: {
        buttonClick(key) {
            let close = this.$thisFrame.close;
            if (this._events.onbuttonClick)
                this.$emit('onButtonClick',key)
            else
                close(false,'key')
        }
    }
}
</script>

<style scoped>

    .layer_wrap {
        height: 100%;
        box-sizing: border-box;
        border: 1px solid #223462;
        box-shadow: 0 0 0 1px #1c1f39, 0 2px 8px rgba(0, 0, 0, .4);
        border-radius: 3px;
        background: #1C1F39;
        display: flex;
        flex-direction: column;
    }

    .content {
        width: 300px;
        max-height: 300px;
        padding: 30px 63px;
        font-size: 14px;
        color: #bedaff;
    }

    .button_wrap {
        height: 76px;

        border-top: 1px solid #223462;

        display: flex;
        align-items: center;
        justify-content: center;
        background: #1b213d;
    }

    .button {
        width: 98px;
        text-align: center;
    }
</style>